import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { isArray } from "util";
import { get } from "lodash";
import { KlPreferenceSaveFormComponent } from "@app/modules/shared/components/preference-form/kl-preference-save-form.component";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { ConvertIsoDateService } from "@app/modules/shared/services/convert-iso-date.service";

interface ReportItem {
  label: string;
  key: string;
  value: any;
  accessor?: string;
}

@Component({
  selector: "kl-report-filter",
  templateUrl: "./kl-report-filter.component.html",
  styleUrls: ["./kl-report-filter.component.scss"],
})
export class KlReportFilterComponent implements OnInit {
  @ViewChild("entryModal", { static: true }) private entryModal: any;
  @ViewChild(forwardRef(() => KlPreferenceSaveFormComponent), {
    static: true,
  })
  klPreferenceSaveFormComponent: any;
  @Output() onApplyReport = new EventEmitter<any>();
  @Output() onSelectReport = new EventEmitter<any>();
  @Output() onClearAll = new EventEmitter<any>();
  @Output() onDeleteFromValues = new EventEmitter<any>();
  @Output() onDeleteSavedReport = new EventEmitter<any>();
  @Output() onCloseReport = new EventEmitter<any>();
  @Output() onCloseAlert = new EventEmitter<any>();
  @Output() onGetReports = new EventEmitter<any>();

  // inputs
  @Input() selectedReportFilterValues: Array<ReportItem> = [];
  @Input() designList = [];
  @Input() currentReport: any;
  @Input() parentModule: string;
  @Input() module: string;
  @Input() key: string;
  @Input() type: string;
  @Input() saveForm = false;
  @Input() loadReport = false;
  @Input() sourceData: any;
  @Input() alertMessage: string;
  @Input() alertShow: boolean;

  reportType: string;
  tableOrPivotType: string;
  tableOrPivot = true;

  get = get;

  constructor(
    private translateService: TranslateService,
    private dateConvert: ConvertIsoDateService
  ) {}

  ngOnInit() {
    this.tableOrPivot = true;
    this.tableOrPivotType = "list_report";
    this.reportType = "";
  }

  isArray(value) {
    return !!Array.isArray(value);
  }

  getTranslated(item, accessor?) {
    let string = "";
    if (isArray(item)) {
      item.forEach((i) => {
        string += this.translateService.instant(get(i, accessor)) + ", ";
      });
      return string;
    } else {
      if (accessor) {
        string += this.translateService.instant(get(item, accessor));
        return string;
      } else {
        string += this.translateService.instant(item);
        return string;
      }
    }
  }

  getReports() {
    this.onGetReports.emit();
  }

  isDate(value) {
    return value instanceof Date;
  }

  convertDate(value) {
    return this.dateConvert.convertDateAndTime(value);
  }

  deleteFromValues(i: number, item: ReportItem) {
    this.onDeleteFromValues.emit({ index: i, item: item });
  }

  deleteSavedReport(i: number, item: any) {
    this.onDeleteSavedReport.emit({ index: i, item: item });
  }

  selectReport(item) {
    this.onSelectReport.emit(item);
  }

  closeReport() {
    this.onCloseReport.emit();
  }

  closeAlert() {
    this.onCloseAlert.emit();
  }

  applyReport() {
    this.reportType = this.tableOrPivot
      ? this.tableOrPivotType
      : this.reportType;
    this.onApplyReport.emit({ report_type: this.reportType });
  }

  closeEntryModal() {
    this.klPreferenceSaveFormComponent.hide();
  }

  openDesigner(type: string, item?: any) {
    const newWindow: any = window.open("report-designer", "_blank");
    newWindow.currentReport = JSON.stringify(item);
    newWindow.mode = type;
    if (type === "add") {
      newWindow.parentModule = this.parentModule;
      newWindow.module = this.module;
      newWindow.key = this.key;
      newWindow.type = this.type;
      newWindow.sourceData = this.sourceData;
    }
    if (type === "edit") {
      newWindow.currentReport = JSON.stringify(item);
      newWindow.parentModule = this.parentModule;
      newWindow.module = this.module;
      newWindow.key = this.key;
      newWindow.type = this.type;
      newWindow.sourceData = this.sourceData;
    }
    newWindow.blur();
  }
}
